import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import Icon from 'components/Icon';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  paper: {
    width: '522px',
    maxWidth: 'calc(100% - 32px)',
    borderRadius: '16px',
    padding: '24px',
    '& .MuiDialogTitle-root': {
      padding: 0,
      fontSize: '20px',
      marginBottom: '24px',
      position: 'relative',
      paddingRight: '28px',
      '& .closeIconWrap': {
        position: 'absolute',
        right: '-10px',
        top: '-2px',
        cursor: 'pointer',
        width: '40px',
        height: '40px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      },
      '& .closeIcon': {
        width: '14px',
      },
    },
    '& .MuiDialogContent-root': {
      padding: 0,
      fontSize: '16px',
      fontWeight: 400,
      color: '#637381',
      marginBottom: '24px',
    },
    '& .MuiDialogActions-root': {
      padding: 0,
    },
  },
});

const NotLoggedInModal = ({ open, onCancel, onConfirm }) => {
  return (
    <Dialog
      open={open}
      onClose={onCancel}
      classes={useStyles()}
      aria-labelledby="not-logged-in-title"
      aria-describedby="not-logged-in-description"
    >
      <DialogTitle id="not-logged-in-title">
        您尚未登入
        <div className="closeIconWrap" onClick={() => onCancel && onCancel()}>
          <Icon name="CloseNotification" className="closeIcon" />
        </div>
      </DialogTitle>
      <DialogContent id="not-logged-in-description">
        請先登入南一帳號或教育雲端帳號，即可繼續使用電子書
      </DialogContent>
      <DialogActions>
        <Button
          onClick={() => onCancel && onCancel()}
          variant="outlined"
          style={{ background: '#F2F4F8', minWidth: 'auto', width: 'auto', whiteSpace: 'nowrap', padding: '6px 16px' }}
        >
          取消
        </Button>
        <Button
          onClick={() => onConfirm && onConfirm()}
          variant="contained"
          style={{ background: '#121232', color: 'white', minWidth: 'auto', width: 'auto', whiteSpace: 'nowrap', padding: '6px 16px' }}
        >
          確定
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default NotLoggedInModal;
